/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CatalogItem,
    CatalogItemFromJSON,
    CatalogItemFromJSONTyped,
    CatalogItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface DealUpdate
 */
export interface DealUpdate {
    /**
     * 
     * @type {number}
     * @memberof DealUpdate
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof DealUpdate
     */
    readonly user?: number;
    /**
     * 
     * @type {CatalogItem}
     * @memberof DealUpdate
     */
    estate?: CatalogItem;
    /**
     * 
     * @type {number}
     * @memberof DealUpdate
     */
    readonly appeal?: number;
    /**
     * 
     * @type {number}
     * @memberof DealUpdate
     */
    readonly agreedContract?: number;
    /**
     * 
     * @type {string}
     * @memberof DealUpdate
     */
    readonly status?: DealUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DealUpdate
     */
    readonly stage?: DealUpdateStageEnum;
    /**
     * 
     * @type {Date}
     * @memberof DealUpdate
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DealUpdate
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof DealUpdate
     */
    readonly amoStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof DealUpdate
     */
    readonly number?: string;
    /**
     * 
     * @type {string}
     * @memberof DealUpdate
     */
    readonly date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DealUpdate
     */
    readonly noteSend?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DealUpdate
     */
    typeOfProperty?: DealUpdateTypeOfPropertyEnum;
    /**
     * 
     * @type {string}
     * @memberof DealUpdate
     */
    basePaymentType?: DealUpdateBasePaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DealUpdate
     */
    additionalPaymentType?: DealUpdateAdditionalPaymentTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DealUpdate
     */
    dutyPaid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DealUpdate
     */
    paymentPeriod?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealUpdate
     */
    paymentInitialFee?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DealUpdate
     */
    paymentMonthly?: number | null;
}

export function DealUpdateFromJSON(json: any): DealUpdate {
    return DealUpdateFromJSONTyped(json, false);
}

export function DealUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DealUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'estate': !exists(json, 'estate') ? undefined : CatalogItemFromJSON(json['estate']),
        'appeal': !exists(json, 'appeal') ? undefined : json['appeal'],
        'agreedContract': !exists(json, 'agreedContract') ? undefined : json['agreedContract'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'stage': !exists(json, 'stage') ? undefined : json['stage'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'amoStatus': !exists(json, 'amoStatus') ? undefined : json['amoStatus'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'noteSend': !exists(json, 'noteSend') ? undefined : json['noteSend'],
        'typeOfProperty': !exists(json, 'typeOfProperty') ? undefined : json['typeOfProperty'],
        'basePaymentType': !exists(json, 'basePaymentType') ? undefined : json['basePaymentType'],
        'additionalPaymentType': !exists(json, 'additionalPaymentType') ? undefined : json['additionalPaymentType'],
        'dutyPaid': !exists(json, 'dutyPaid') ? undefined : json['dutyPaid'],
        'paymentPeriod': !exists(json, 'paymentPeriod') ? undefined : json['paymentPeriod'],
        'paymentInitialFee': !exists(json, 'paymentInitialFee') ? undefined : json['paymentInitialFee'],
        'paymentMonthly': !exists(json, 'paymentMonthly') ? undefined : json['paymentMonthly'],
    };
}

export function DealUpdateToJSON(value?: DealUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'estate': CatalogItemToJSON(value.estate),
        'typeOfProperty': value.typeOfProperty,
        'basePaymentType': value.basePaymentType,
        'additionalPaymentType': value.additionalPaymentType,
        'dutyPaid': value.dutyPaid,
        'paymentPeriod': value.paymentPeriod,
        'paymentInitialFee': value.paymentInitialFee,
        'paymentMonthly': value.paymentMonthly,
    };
}

/**
* @export
* @enum {string}
*/
export enum DealUpdateStatusEnum {
    New = 'new',
    Complete = 'complete',
    Canceled = 'canceled'
}
/**
* @export
* @enum {string}
*/
export enum DealUpdateStageEnum {
    Booking = 'booking',
    TypeOfOwnership = 'type_of_ownership',
    LoadOwners = 'load_owners',
    PayOptions = 'pay_options',
    LoadPayData = 'load_pay_data',
    Agreement = 'agreement',
    SigningOptions = 'signing_options',
    CheckContractSigned = 'check_contract_signed',
    PayStateDuty = 'pay_state_duty',
    Transaction = 'transaction',
    PayUnderContract = 'pay_under_contract',
    Final = 'final',
    SendDealData = 'send_deal_data'
}
/**
* @export
* @enum {string}
*/
export enum DealUpdateTypeOfPropertyEnum {
    Single = 'single',
    Spouses = 'spouses',
    SpousesSingle = 'spouses_single',
    SharedOwnership = 'shared_ownership',
    SharedOwnershipWithChildren = 'shared_ownership_with_children'
}
/**
* @export
* @enum {string}
*/
export enum DealUpdateBasePaymentTypeEnum {
    Payment100 = 'payment_100',
    TradeIn = 'trade_in',
    Mortgage = 'mortgage',
    InstallmentPayment = 'installment_payment'
}
/**
* @export
* @enum {string}
*/
export enum DealUpdateAdditionalPaymentTypeEnum {
    Nope = 'nope',
    MaternalCapital = 'maternal_capital',
    HousingCertificate = 'housing_certificate',
    MilitaryCertificate = 'military_certificate'
}


